<script>
import roundHelper from './mixins/roundHelper';
import Table from '@/views/tournaments/management/brackets/components/TableView';

const filterRounds = ({ grid_index }) => {
  return grid_index !== -1;
};
const sortRounds = rounds => {
  const roundsUpper = rounds.filter(({ grid }) => grid === 'upper');
  const roundsLower = rounds.filter(({ grid }) => grid === 'lower');
  const hasGrandFinal = (roundsUpper.length - roundsLower.length / 2) % 2; // why? - ask @olsy
  const roundsFinish = roundsUpper.splice(-1 - hasGrandFinal);

  return [...roundsUpper, ...roundsLower, ...roundsFinish];
};

export default {
  name: 'TournamentDoubleEliminationTableView',
  functional: true,
  props: {
    roundID: {
      type: [Number, String],
      default: 0,
    },
  },
  render(h, context) {
    return h(Table, {
      props: {
        roundID: context.props.roundID,
        grids: ['upper', 'lower'],
        roundName: roundHelper.methods.roundNameTable,
        sortRounds: sortRounds,
        prepareMenuItems: {
          filter: filterRounds,
        },
      },
      on: context.listeners,
    });
  },
};
</script>
